<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <span class="configurationBannerLabel">Performance Results</span>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        <span class="configurationInput">
          <span class="configurationInputLabel">Airflow:</span>
          <input readonly="readonly" [value]="airflow" class="configurationRatingValueOutput">
          <span class="configurationRatingUnitLabel">{{ getAirflowMeasurementUnits(false) }}</span>
        </span>
        <span class="configurationInput">
          <span class="configurationInputLabel">BHP:</span>
          <input readonly="readonly" [value]="brakingHorsepower" class="configurationRatingValueOutput">
        </span>
        <span class="configurationInput">
          <span class="configurationInputLabel">FLA:</span>
          <input readonly="readonly" [value]="fullLoadAmps" class="configurationRatingValueOutput">
        </span>
      </div>
      <div class="configurationDetailRow">
        <span class="configurationInput">
          <span class="configurationInputLabel">Standard Airflow:</span>
          <input readonly="readonly" [value]="standardAirflow" class="configurationRatingValueOutput">
          <span class="configurationRatingUnitLabel">{{ getAirflowMeasurementUnits(true) }}</span>
        </span>
      </div>
      <app-performance-results [ratingResponse]="ratingResponse()" [isMetric]="isMetric">
      </app-performance-results>
    </div>
  }
</div>
